import { Accordion } from '@arcflight/tf-component-library';
import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DashboardState } from '../../models';
import { CustomField } from '../../models/aircraft';
import { TripUpdate } from '../../models/trips';
import customFieldsIcon from '../../assets/icon-card-custom-fields-main.svg';
import { DataValue } from '../../utils/updateLocalDataObject';
import CustomFieldSection from '../CustomFieldSection/CustomFieldSection';
import { PartsDiv, RowHeader, TitleWrapper } from './TripUpdateAirframeSection';

interface TripUpdateCustomFieldsSectionProps {
  trip: TripUpdate;
  updateTripUpdateData: (changes: { value: DataValue; key: string }[]) => void;
}

const OuterWrapper = styled.div`
  border: solid 2px #fff;
  background-color: rgba(255, 255, 255, 0);
  padding: ${({ isMobile }): string => (isMobile ? '16px 20px' : '16px 0 20px 56px')};
`;

const TripUpdateCustomFieldsSection: React.FC<TripUpdateCustomFieldsSectionProps> = ({
  trip,
  updateTripUpdateData,
}) => {
  const {
    drawer: { mode },
    aircraft: { aircraftMap },
  } = useSelector((state: DashboardState) => state);

  const { id } = useParams<{ id: string }>();

  const fieldCount = Object.values(aircraftMap.get(id)?.custom_fields || {}).filter(
    (field: CustomField) => field?.view === 'trip_update',
  ).length;

  const isMobile = window.innerWidth < 451;

  return (
    <Accordion
      isExpanded={mode === 'add' || mode === 'edit' || mode === 'override'}
      dash
      headerContent={
        <RowHeader data-testid="TripUpdateCustomFieldsSection--Accordion">
          <TitleWrapper>
            <img src={customFieldsIcon} alt="custom fields" />
            Custom fields
          </TitleWrapper>
          <PartsDiv>{`${fieldCount} ${fieldCount === 1 ? 'field' : 'fields'}`}</PartsDiv>
        </RowHeader>
      }
    >
      <OuterWrapper isMobile={isMobile}>
        <CustomFieldSection
          customData={trip?.custom_data}
          saveKey="custom_data"
          updateData={updateTripUpdateData}
          customFieldKey="trip_update"
        />
      </OuterWrapper>
    </Accordion>
  );
};

export default TripUpdateCustomFieldsSection;
